import lodash from "lodash";

export default {
  install: function(app /*, options*/) {
    app._ = lodash;
    window._ = lodash;
    Object.defineProperties(app.config.globalProperties, {
      _: {
        get() {
          return lodash;
        }
      },
      $_: {
        get() {
          return lodash;
        }
      }
    });
  }
};
